class LoadingSpinner {
    add(target) { // eslint-disable-line class-methods-use-this
        const loadingSpinner = '<div class="spinner-border-overlay"><div class="spinner-border" role="status">\n'
            + '<span class="visually-hidden">Loading...</span>\n'
            + '</div></div>';
        if (target) {
            document.querySelector(target).insertAdjacentHTML('beforeend', loadingSpinner);
        } else {
            console.log('LoadingSpinner added to default');
            document.body.insertAdjacentHTML('beforeend', loadingSpinner);
        }
    }

    remove() { // eslint-disable-line class-methods-use-this
        document.querySelectorAll('.spinner-border-overlay').forEach((spinner) => spinner.remove());
    }
}

export default LoadingSpinner;
